import React from "react";
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import CircularProgress from '@material-ui/core/CircularProgress'
import { Helmet } from "react-helmet";
import axios from 'axios';
import { Card, CardHeader, CardBody, Container, Row, Col, Modal, Input,} from "reactstrap";
// import { MessageBox } from 'react-chat-elements'
// import logo from 'assets/img/place.png';
import Chat from '../../components/Self/Chat.js'
import Refresh from '@material-ui/icons/SyncProblem';

import moment from "moment";
import { Link } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import Search from '@material-ui/icons/Search';
import Close from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip'

import { withStyles } from "@material-ui/core/styles";

const CTooltip = withStyles({ tooltip: { fontSize: "14px", padding: '7px', }})(Tooltip);

const Icons = (props) => {
    // const history = useHistory();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [allloading, setallloading] = React.useState(true);
    const [newchat, setnewchat] = React.useState(false);
    const [recentchats, setrecentchats] = React.useState([]);
    const [searchopen1, setsearchopen1] = React.useState(false);
    const [searchopen2, setsearchopen2] = React.useState(false);

    const [responseData, setResponseData] = React.useState([]);

    const handleClosenewchat = () => {
        setnewchat(false)
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const urlo = process.env.REACT_APP_DOMAIN+"/allaccounts"
    const fetchData = React.useCallback((recent) => {
        recent=[]
        axios.get(process.env.REACT_APP_DOMAIN+"/recentchats", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response)
                // setChats(response.data)
                console.log(response.data)
                response.data.map(function (chat, index) {
                    // console.log(chat.sender)
                    if(chat.sender.id === props.username){
                        // console.log('yes')
                        // console.log(recent)
                        if (recent.map(a => a.username).includes(chat.receiver.username)) {
                            // console.log('Includes')
                        }
                        else {
                            if (chat.image !== null) {
                                recent.push({ username: chat.receiver.username,photo: chat.receiver.photo,sent: moment(chat.sent).fromNow(), id: chat.receiver.id, lastm: "You : Image",type: 'self' })
                            }
                            else {
                                if (chat.file !== null) {
                                    recent.push({ username: chat.receiver.username, photo: chat.receiver.photo, sent: moment(chat.sent).fromNow(), id: chat.receiver.id, lastm: "You : File", type: 'self' })
                                }
                                else{
                                    recent.push({ username: chat.receiver.username,photo: chat.receiver.photo,sent: moment(chat.sent).fromNow(), id: chat.receiver.id, lastm: "You : "+ chat.message,type: 'self'})   
                                }      
                            }
                           
                        }
                    }
                    else {
                        if (recent.map(a => a.username).includes(chat.sender.username)) {
                            // console.log('Includes')
                        }
                        else {
                            if (chat.image !== null) {
                                recent.push({ username: chat.sender.username,photo: chat.sender.photo,sent: moment(chat.sent).fromNow(), id: chat.sender.id, lastm: "Image",type: 'diff',seen: chat.seen })
                            }
                            else {
                                if (chat.file !== null) {
                                    recent.push({ username: chat.sender.username, photo: chat.sender.photo, sent: moment(chat.sent).fromNow(), id: chat.sender.id, lastm: "File", type: 'diff', seen: chat.seen })
                                }
                                else{
                                    recent.push({ username: chat.sender.username,photo: chat.sender.photo,sent: moment(chat.sent).fromNow(), id: chat.sender.id, lastm: chat.message,type: 'diff',seen: chat.seen })
                                }
                            }
                        }
                    }
                    // console.log(recent)
                    // data2.push(chat)
                    return(null)
                })
                // console.log(recent)
                setrecentchats(recent)
            })
            .catch((error) => {
                console.log(error)
                settt('error')
                setSendingdata("Something went wrong")
                setOpen(true);
            })
        axios.get(urlo, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setResponseData(response.data)
                setallloading(false)
            })
            .catch((error) => {
                console.log(error)
                settt('error')
                setSendingdata("Something went wrong")
                setOpen(true);
            })
        // titleRef.current.scrollTop = titleRef2.current.offsetTop
    }, [props.token,props.username,urlo])
    


    React.useEffect(() => {
        fetchData()
        // setInterval(() => {
        //     // console.log('fetching.........')
        //     fetchData();
        // }, 10000)
        document.title = "Messaging - Depact"
    }, [fetchData])

    const recent2 = [];
    if (recentchats) {
        // console.log(recentchats)
        recentchats.map(function (responseData, index) {
            recent2.push(responseData)
            return(null)
        })
    }
    const data2 = [];
    if (responseData) {
        responseData.map(function (responseData, index) {
            if (recent2.map(a => a.username).includes(responseData.username)) {
                // console.log('Includes')
            }
            else {
                if (responseData.id === props.username) {
                    // console.log('AAAAAAAAAAHHHHHHHH')
                }
                else{
                    data2.push(responseData)    
                }
                
            }
            return(null)
            
        })
    }



    const handleOnChange1 = (event) => {
        // console.log(event.target.value)
        if (event.target.value <= 0) {
            fetchData()
            return 0;
        }
        var i;
        var input = event.target.value.toLowerCase();
        let x = document.getElementsByClassName('main-chats');
        // console.log(x.length)
        if (input.length > 2) {
            for (i = 0; i < x.length; i++) {

                if (!x[i].innerHTML.toLowerCase().includes(input)) {
                    x[i].style.display = 'none'
                }
                else {
                    x[i].style.display = "";
                }
            }
        }
        else {
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "";
            }
        }

    };



    const handleOnChange2 = (event) => {
        // console.log(event.target.value)
        if (event.target.value <= 0) {
            fetchData()
            return 0;
        }
        var i;
        var input = event.target.value.toLowerCase();
        let x = document.getElementsByClassName('new-chats');
        // console.log(x.length)
        if (input.length > 2) {
            for (i = 0; i < x.length; i++) {

                if (!x[i].innerHTML.toLowerCase().includes(input)) {
                    x[i].style.display='none'
                }
                else {
                    x[i].style.display = "";
                }
            }
        }
        else {
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "";
            }
        }

    };

    return (
        <>
            <div className="header bg-gradient-infco pb-8 pt-5 pt-md-7 mobile-no-mt mobile-no-mb">
                <Container fluid>
                    <div className="header-body">
                    </div>
                </Container>
            </div>
            {/* Page content */}
            <Container className="mt--7 pt-0 mb-4 mobile-no-p mobile-min-mt" fluid>
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="theme-color" content="#ffffff" />
                    <meta name="description" content={'Message Depact Users'} />
                    <meta property="og:description" content={'Message Depact Users'} />
                    <meta property="og:title" content='DepAct' />
                    <meta property="og:type" content="Messaging" />
                    <meta property="og:url" content={"https://depact-kjsieit.vercel.app/main/messaging"} />
                </Helmet>
                <Row className="pt-0">
                    <Col className="bg-bh pt-0" lg="12">
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardBody className="pt-0 pb-0 pl-0 pr-0">
                                <CardHeader className={"cardbg-" + props.theme + " cardb-" + props.theme}>
                                    <div style={{display: 'flex'}}>
                                        <h2 style={{ flex: 1 }} className={"no-w mt-2 textb-" + props.theme}>Recent ({recent2.length})</h2>
                                        {(searchopen1 ?
                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <Input placeholder='Search Recents' autoFocus onChange={handleOnChange1} />
                                                <IconButton disableRipple onClick={() => { setsearchopen1(false) }}><Close /></IconButton>
                                            </div>
                                            :
                                            <CTooltip arrow title='Search Chats' placement='top' ><IconButton disableRipple onClick={() => { setsearchopen1(true) }} ><Search /></IconButton></CTooltip>
                                        )}
                                        <CTooltip arrow title='Refresh Chats' placement='top' ><IconButton disableRipple color="" className="ml-3" size="medium" aria-label="add" onClick={fetchData} >
                                            <Refresh />
                                        </IconButton></CTooltip>
                                        <CTooltip arrow title='Start New Chat' placement='top' ><IconButton disableRipple color="" className="ml-3" size="medium" aria-label="add" onClick={()=>{setnewchat(true)}} >
                                            <AddIcon />
                                        </IconButton></CTooltip>
                                    </div>
                                    
                                </CardHeader>
                                <div className="no-scrollbar " style={{ minHeight: '500px', maxHeight: '500px', overflowY: 'scroll' }}>
                                    {(allloading ?
                                        <div><CircularProgress size="40px" /></div>
                                        :
                                        recent2.map(function (resp, index) {
                                            if (resp.type === 'self') {
                                                return (
                                                    <div className='main-chats'>
                                                    <Link to={'message/' + resp.id}>
                                                        <Chat name={resp.username} message={resp.lastm} extra={resp.sent} type={false} pro={process.env.REACT_APP_DOMAIN + "" + resp.photo} />
                                                    </Link></div>
                                                )
                                            }
                                            else {
                                                if (resp.seen === false) {
                                                    return (
                                                        <div className='main-chats' >
                                                        <Link to={'message/' + resp.id}>
                                                            <Chat name={resp.username} message={resp.lastm} extra={resp.sent} type={true} pro={process.env.REACT_APP_DOMAIN + "" + resp.photo} />
                                                        </Link></div>
                                                    )
                                                }
                                                else {
                                                    return (
                                                    <div className='main-chats'>
                                                        <Link to={'message/' + resp.id}>
                                                            <Chat name={resp.username} message={resp.lastm} extra={resp.sent} type={false} pro={process.env.REACT_APP_DOMAIN + "" + resp.photo} />
                                                        </Link></div>
                                                    )
                                                }

                                            }
                                        })
                                    )
                                    }
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                <Col className="bg-dc mobile-h2" lg="8">
                        <Modal
                            className="modal-dialog-centered"
                            size="lg"
                            isOpen={newchat}
                            toggle={handleClosenewchat}>
                                <CardHeader className={"cardbg-" + props.theme + " cardb-" + props.theme}>
                                    <div style={{ display: 'flex' }}>
                                        <h2 style={{ flex: 1 }} className={"no-w mt-2 textb-" + props.theme}>New Chat</h2>
                                        {(searchopen2 ?
                                            <div style={{ flex: 1, display: 'flex' }}>
                                                <Input placeholder='Search New Chats' autoFocus onChange={handleOnChange2} />
                                                <IconButton disableRipple onClick={() => { setsearchopen2(false) }}><Close /></IconButton>
                                            </div>
                                            :
                                            <IconButton disableRipple onClick={() => { setsearchopen2(true) }} ><Search /></IconButton>
                                        )}
                                        {/* <IconButton disableRipple color="" className="ml-3" size="medium" aria-label="add" onClick={() => { setnewchat(true) }} >
                                            <AddIcon />
                                        </IconButton> */}
                                    </div>
                                </CardHeader>
                            <Row className="modal-body bg-orangec pt-0">
                                <div className="no-scrollbar " style={{ minHeight: '500px', maxHeight: '500px', overflowY: 'scroll', width: '100%' }}>
                                    {(data2 === undefined ?
                                        <div>Select Chat</div>
                                        :
                                        data2.map(function (resp, index) {
                                            // console.log(resp)
                                            var tt = 'User'
                                            if(resp.is_superuser===true){
                                                tt='Admin'
                                            }
                                            else{
                                                if(resp.is_staff ===true){
                                                    tt='Faculty'
                                                }
                                                else{
                                                    tt='Student'
                                                }
                                            }
                                            // console.log(typeof (resp.username))
                                            return (
                                                <div className='new-chats'>
                                                <Link to={'message/' + resp.id}>
                                                    <Chat name={resp.username} message={resp.email} extra={tt} type={false} pro={process.env.REACT_APP_DOMAIN + "" + resp.photo} />
                                                </Link></div>
                                            )
                                        })
                                    )
                                    }
                                </div>
                            </Row>
                        </Modal>
                </Col>
                </Row>
            </Container>
            <Container className="mt-0" fluid>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Icons);
